import { transformSectionToLocationItems } from './transformSectionToLocationItems';
import filterByType from '../../components/cdBuilder/utilities/filterByType';
import { ICDViewItemGroups } from '../../ui-toolkit/cdItems/interfaces/ICDViewItemCollection';
import { eCDV3ItemTypes } from '../../ui-toolkit/enums/eCDV3ItemTypes';

export const getItemLocation = (id: string, items: ICDViewItemGroups) => {
  return [
    ...transformSectionToLocationItems('A', items.origination),
    ...transformSectionToLocationItems('B', items.services_not_shopped_for),
    ...transformSectionToLocationItems('C', items.services_shopped_for),
    ...transformSectionToLocationItems('E', items.recording_fees_and_taxes, 2),
    ...transformSectionToLocationItems('F', items.prepaids),
    ...transformSectionToLocationItems('H', items.other_costs),
    ...transformSectionToLocationItems('Payoff ', items.payoffs ? { items: items.payoffs } : null),
    ...transformSectionToLocationItems(
      'K',
      items.due_from_buyer
        ? { items: items.due_from_buyer.items.filter(filterByType(eCDV3ItemTypes.buyer_reimbursement_to_third_party)) }
        : null,
      5
    ),
    ...transformSectionToLocationItems(
      'K',
      items.due_from_buyer
        ? {
            items: items.due_from_buyer.items.filter(
              filterByType(
                eCDV3ItemTypes.buyer_reimbursement_to_seller,
                eCDV3ItemTypes.buyer_reimbursement_other_to_seller
              )
            ),
          }
        : null,
      8
    ),
    ...transformSectionToLocationItems(
      'L',
      items.paid_already_by_buyer
        ? {
            items: items.paid_already_by_buyer.items.filter(
              filterByType(eCDV3ItemTypes.buyer_credit_from_seller, eCDV3ItemTypes.buyer_credit_from_third_party)
            ),
          }
        : null,
      6
    ),
    ...transformSectionToLocationItems(
      'L',
      items.paid_already_by_buyer
        ? {
            items: items.paid_already_by_buyer.items.filter(
              filterByType(
                eCDV3ItemTypes.buyer_reimbursement_from_seller,
                eCDV3ItemTypes.buyer_reimbursement_other_from_seller
              )
            ),
          }
        : null,
      12
    ),
    // ...transformSectionToLocationItems('M', items.due_to_seller),// disabled because K validates the same data
    // ...transformSectionToLocationItems('N', items.due_from_seller)// disabled because K validates the same data
  ].find((item) => item.id === id);
};
